import React, {useEffect, useState } from "react";
import {  getJobApplication, 
    updateApplicantRating,
    updateApplicantStatus,
    // getLoggedInUser,
 } from "../../utils/helper";
import Loader from "../../utils/Loader";
import { useParams, useHistory } from "react-router-dom";
import { alertError, 
    // alertSuccess
 } from "../../utils/alerts";


const INIT_STATE = {
    jobTitle: "",
    id: "",
};

const ratings = ["suitable", "maybe", "not suitable", "not rated"]
const statuses = [
    {name:"shortlisted", label:"Shortlist Candidate"}, 
    {name:"hired", label: "Hire Candidate"}, 
    {name:"rejected", label:"Reject Candidate"}, 
    {name:"scheduled for interview", label:"Schedule for Interview"},
]

export default function ViewJobOpening() {
    const { id } = useParams();
    const history = useHistory();
    const [loading, setLoading] = useState(true);
    const [state, setState] = useState(INIT_STATE);
    const [applications, setApplications] = useState(null);
    const [applicant, setApplicant] = useState({});
    // const [profile, setProfile] = useState("");
    // const TOKEN = localStorage.getItem("kloka:token:data");

    // useEffect(()=>{
    //     if(TOKEN){
    //         getLoggedInUser(TOKEN).then((res) => {
    //             setProfile(res.data.data);
    //         });
    //     }
    // }, [TOKEN]);

    useEffect(() => {
        if(id){
            getJobApplication(id)
                .then((res) => {
                    if(res.data.success){
                        setApplications(res.data.data);
                        setInterval(() => {
                            setLoading(false)
                        }, 1200);
                    } else {
                        alertError(res.data.message);
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    console.log(err?.response?.data?.error)
                    setLoading(false);
                });
        }
    }, [id]); 

    useEffect(() => {
        setState((prev) => ({
            ...prev,
            id: (applications && applications.job_id ) || "",
            jobTitle: (applications && applications?.job_id?.jobTitle ) || "",
        }));
    }, [applications]);

    const navigateBack = () => {
        history.goBack();
    };

    const handleSetApplicant = async (row) => {
        if(row){
            setApplicant((prev) => ({
                ...prev,
                id: (row && row._id) || "",
                candidate_name: (row && row.candidate_name) || "",
                candidate_email: (row && row.candidate_email) || "",
                candidate_phone: (row && row.candidate_phone) || "",
                candidate_address: (row && row.candidate_address) || "",
                candidate_country: (row && row.candidate_country) || "",
                candidate_cv: (row && row.candidate_cv) || "",
                candidate_linkedin: (row && row.candidate_linkedin) || "",
                rating: (row && row.rating) || "",
                view: (row && row.view) || "",
                status: (row && row.status) || "",
                createdAt: (row && row.createdAt) || "",
            }));
        }
    }

    const handleRateApplicant = async (data) => {
        setLoading(true);
        updateApplicantRating(data)
            .then((res) => {
                if(res.data.success){
                    setApplicant((prev) => ({
                        ...prev,
                        rating: data.rating,
                    }));
                    setInterval(() => {
                        setLoading(false)
                    }, 1200);
                }
            })
            .catch((err) => {
                console.log(err.response.data.message)
            })
    }

    const handleStatusApplicant = async (data) => {
        setLoading(true);
        updateApplicantStatus(data)
            .then((res) => {
                if(res.data.success){
                    setApplicant((prev) => ({
                        ...prev,
                        status: data.status,
                    }));
                    setInterval(() => {
                        setLoading(false)
                    }, 1200);
                }
            })
            .catch((err) => {
                console.log(err.response.data.message)
            })
    }

    const RateButton = ({ rating, app_id, app_rating }) => {
        const data = {
            id: app_id,
            rating: rating
        }
        return (
            <button 
                onClick={() => handleRateApplicant(data)} 
                className={`btn job_card_btn job_card_btn_primary ${rating === app_rating ? 'active' : null}`}
            >
                {rating}
            </button>
        )
    }

    const StatusButton = ({ name, label, app_id, app_status }) => {
        const data = {
            id: app_id,
            name: name
        }
        return (
            <button 
                onClick={() => handleStatusApplicant(data)} 
                className={`btn job_card_btn job_card_btn_primary ${name === app_status ? 'active' : null}`}
            >
                {label}
            </button>
        )
    }

    return (
        <>  
            <h1 className="dash-title">
                <button onClick={navigateBack} style={{color: '#454545', border:'none', backgroundColor:'transparent', fontWeight:'bold'}}>
                    <i className="fa fa-arrow-left"></i> Go Back
                </button>
            </h1>

            <div className="row dash-row">
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Job Applicants: {state.jobTitle && state.jobTitle}</div>
                            <div className="spur-card-menu">
                                {/* <form className="btn-group" onSubmit={()=> console.log(state)}> */}
                                    <select className="form-control form-select" required="required" name="sort" 
                                    onChange={()=> console.log('sort')}>
                                        <option value=''>Sort by</option>
                                        <option value='shortlisted'>Shortlisted</option>
                                        <option value='scheduled for interview'>Scheduled for Interview</option>
                                        <option value='hired'>Hired</option>
                                        <option value='rejected'>Rejected</option>
                                    </select>
                                {/* </form> */}
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="my_profile">
                                {!loading ? <>                                    
                                    <div className="row">
                                        {(applications && applications.length > 0) ? <>   
                                            
                                            <div className="col-md-3 col-sm-6">
                                                <div className="row">
                                                    {applications && applications.map((row, i) => (
                                                        <div className="col-12" key={i}>
                                                            <button onClick={()=> handleSetApplicant(row)} className="applicant_card">
                                                                <h5>{row.candidate_name && row.candidate_name}</h5>
                                                                <span className={`${row.rating}`}>{row.rating && row.rating}</span>
                                                                <span className={`${row.status}`}>{row.status && row.status}</span>      
                                                            </button>  
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            <div className="col-md-9 col-sm-6">
                                                <div className="applicant_details">
                                                    {applicant && applicant.candidate_name ? <>
                                                        <div className="pl-3 mt-0 pt-2 pb-2" 
                                                            style={{
                                                                borderBottom:'1px solid #ccc', 
                                                                backgroundColor: "rgba(77, 128, 206, 0.2)"
                                                            }}>
                                                            Rate applicant as:
                                                            
                                                            <span className="ml-4">
                                                                {ratings && ratings.map((rating, i) => (
                                                                    <RateButton 
                                                                        rating={rating} 
                                                                        app_id={applicant.id} 
                                                                        key={i} 
                                                                        app_rating={applicant.rating}
                                                                    />
                                                                ))}
                                                            </span>
                                                        </div>
                                                        
                                                        <ul className="personal-info">
                                                            <li><div className="title">Applicant Name:</div>
                                                                <div className="text">{applicant.candidate_name}</div>
                                                            </li>
                                                            <li><div className="title">Applicant Email:</div>
                                                                <div className="text">{applicant.candidate_email}</div>
                                                            </li>
                                                            <li><div className="title">Applicant Phone:</div>
                                                                <div className="text"> {applicant.candidate_phone}</div>
                                                            </li>
                                                            <li><div className="title">Applicant Address:</div>
                                                                <div className="text">  {applicant.candidate_address}</div>
                                                            </li>
                                                            <li><div className="title">Applicant Country:</div>
                                                                <div className="text"> {applicant.candidate_country}</div>
                                                            </li>
                                                            <li><div className="title">CV Link:</div>
                                                                <div className="text"> 
                                                                    <a href={`${applicant.candidate_cv}`}
                                                                        target="_blank" 
                                                                        rel="noreferrer" 
                                                                        className="btn btn_applicant_view">
                                                                        View CV {"  "}
                                                                        <i className="fa fa-external-link"></i>
                                                                    </a>
                                                                </div>
                                                            </li>
                                                            <li><div className="title">LinkedIn Link:</div>
                                                                <div className="text"> {applicant.candidate_linkedin}</div>
                                                            </li>
                                                        </ul>
                                                        
                                                        <div className="pl-3 mt-0 pt-2 pb-2" 
                                                            style={{
                                                                borderTop:'1px solid #ccc', 
                                                                backgroundColor: "rgba(0, 153, 51, 0.1)"
                                                            }}>

                                                            
                                                            
                                                            <span className="ml-0">
                                                                {statuses && statuses.map((status, i) => (
                                                                    <StatusButton 
                                                                        name={status.name} 
                                                                        label={status.label} 
                                                                        app_id={applicant.id} 
                                                                        key={i} 
                                                                        app_status={applicant.status}
                                                                    />
                                                                ))}
                                                            </span>
                                                        </div>


                                                    </> : 
                                                        <div className="alert alert-info mb-0" style={{borderRadius:0}}>
                                                            Click on Applicant name to preview applicant information.
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </> : <div className="alert alert-danger myerror">No applicant found.</div> }
                                    </div>
                                </> : <Loader /> }
                            </div>
                        </div>
                    </div> 
                </div>
            </div>
        </>
    );
}
